import { SliderGoogle } from "./style";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, A11y, Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/a11y";
import AvaliacaoUm from "../../../../assets/avaliacoes-google/1.webp";
import AvaliacaoDois from "../../../../assets/avaliacoes-google/2.webp";
import AvaliacaoTres from "../../../../assets/avaliacoes-google/3.webp";
import AvaliacaoQuatro from "../../../../assets/avaliacoes-google/4.webp";
import AvaliacaoCinco from "../../../../assets/avaliacoes-google/5.webp";
import AvaliacaoSeis from "../../../../assets/avaliacoes-google/6.webp";
import AvaliacaoSete from "../../../../assets/avaliacoes-google/7.webp";
import AvaliacaoOito from "../../../../assets/avaliacoes-google/8.webp";
import { FiArrowUpRight } from "react-icons/fi"


function SliderGoogleComponent() {
  const db = [
    {
      img: AvaliacaoUm,
      id: 0,
    },
    {
      img: AvaliacaoDois,
      id: 1,
    },
    {
      img: AvaliacaoTres,
      id: 2,
    },
    {
      img: AvaliacaoQuatro,
      id: 3,
    },
    {
      img: AvaliacaoCinco,
      id: 4,
    },
    {
      img: AvaliacaoSeis,
      id: 5,
    },
    {
      img: AvaliacaoSete,
      id: 6,
    },
    {
      img: AvaliacaoOito,
      id: 7,
    },
  ];

  const width = window.innerWidth;
  let thisWidth2 = 1.05;

  if (width > 1000) {
    thisWidth2 = 3.05;
  } else if (width > 600) {
    thisWidth2 = 2.05;
  }

  return (
    <SliderGoogle>
      <div id="see-title">
        <span id="conf">Credibilidade</span>
        <div id="see">
          <h1>Avaliações no Google</h1>
          <button><a href="https://www.google.com/maps/place/Flavio+Moura+Consultoria/@-23.3185778,-46.2300312,17z/data=!4m8!3m7!1s0x94ce812351b32839:0x9e0dfd45a3198e14!8m2!3d-23.3185778!4d-46.2300312!9m1!1b1!16s%2Fg%2F11nght99sc?entry=ttu&g_ep=EgoyMDI1MDEwNy4wIKXMDSoASAFQAw%3D%3D" target="blank">Ver mais avaliações <FiArrowUpRight/></a></button>
        </div>
      </div>
      <Swiper
        id="slider"
        spaceBetween={5}
        slidesPerView={thisWidth2}
        pagination={true}
        loop={true}
        a11y={true}
        modules={[Pagination, A11y, Autoplay]}
        autoplay={true}
      >
        {db.map((people) => (
          <SwiperSlide className="slides" key={people.id}>
            <div className="id">
              <figure>
                <img src={people.img} alt="Imagem" />
              </figure>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </SliderGoogle>
  );
}

export default SliderGoogleComponent;
